import api from "../../services/service";
import apiCenter from "../../services/service_undefined";
import moment from "moment";
import _ from "lodash";

export default {
  data() {
    return {
      date_start: new Date(),
      date_end: new Date(),
      Sale_amount: 0,
      Profit_amount: 0,
      DashType: 0,
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      total_data: 0,
      profit_data: 0,
      page_type: 1,
      chartType: "stackedBar100",
      chartProduct: false,
      item_group: [],
      data_allbranch: [],
      group_branch: [],
      data_item: [],
      branchLoaded: 0,
      allBranch: 0,
      count_branch: 0,
      allProductStandardCost: [],
      allProductStandardCostProfit: []
      // chartType: 'stackedBar100',
    };
  },
  methods: {
    moment,
    onChange(dates, dateStrings) {
      this.date_start = new Date(dates[0]);
      this.date_end = new Date(dates[1]);

      this.getData();
    },
    ChangeType() {
      // this.$store.state.isLoading = true
      var Data = this.dateFormatDMY2(new Date());
      var res = Data.split("-");
      var month = res[1]; // January
      var year = res[0];
      switch (parseInt(this.DashType)) {
        case 0:
          this.date_start = new Date();
          this.date_end = new Date();
          break;
        case 1:
          this.date_start = this.getWeekStart(new Date());
          this.date_end = this.getWeekEnd(new Date());
          break;
        case 2:
          var d = new Date(year, month, 0);
          this.date_end = d;
          this.date_start = new Date(year, month - 1, 1);
          break;
        case 3:
          this.date_start = new Date(year, 0, 1);
          this.date_end = new Date(year, 12, 0);
      }
      this.branchLoaded = 0;
      this.allBranch = 0;
      this.allProductStandardCost = [];
      this.allProductStandardCostProfit = [];
      this.getData();
    },
    onChangeChart(e) {
      this.branchLoaded = 0;
      this.allBranch = 0;
      this.allProductStandardCost = [];
      this.allProductStandardCostProfit = [];
      // this.$store.state.isLoading = true;
      this.chartType = e.target.value;
      // $('.chart-income').css('display', 'none');
      // this.$store.state.branch_list.map((val,x) => {
      //   this.createReport([],x);
      // });
      // if(this.data_allbranch.length > 0) {
      //   this.item_group.map((val,x) => {
      //     this.createReportProduct([],x);
      //   });
      // }
      if (this.chartProduct) {
        this.clearDashProduct();
        this.callDashBoardBranch();
      } else {
        this.clearDashBranch();
        this.getData();
      }
      // this.$store.state.isLoading = false;
    },
    clearDashProduct() {
      if (this.data_allbranch.length > 0) {
        this.item_group.map((val, x) => {
          this.createReportProduct([], x);
        });
      }
    },
    clearDashBranch() {
      this.profit_data = 0;
      this.data_allbranch = [];
      this.$store.state.branch_list.map((val, x) => {
        this.createReport([], x);
      });
    },
    getData() {
      // this.$store.state.isLoading = true
      if (this.page_type === 1) {
        this.AllDataStandardCost();
      } else {
        this.AllData();
      }

      // this.$store.state.branch_list.map((val,x) => {
      //   this.createReport([],x);
      // });

      // if(this.data_allbranch.length > 0) {
      //   this.item_group.map((val,x) => {
      //     this.createReportProduct([],x);
      //   });
      // }

      var i = 0;
      // console.log(this.$store.state.branch_list);
      this.group_branch = this.$store.state.branch_list.filter(
        val => val.branch_name != "099 โกดังสาขา"
      );
      this.group_branch = this.group_branch.filter(
        val => val.branch_name != "002 ตลาดธานินท์"
      );
      this.allBranch = this.group_branch.length;
      this.group_branch.forEach(val => {
        $("#per" + i).html(this.numberFormatDecimal(0));
        $("#total" + i).html(this.numberFormat(0));
        // eslint-disable-next-line no-undef
        $("#profit" + i).html(this.numberFormat(0));
        if (this.page_type === 1) {
          this.CallDashboardStandardCost(val["id"], i);
        } else {
          this.CallDashboard(val["id"], i);
        }
        i++;
      });
    },
    async callDashBoardBranch() {
      this.data_allbranch = [];

      // this.$store.state.branch_list.map((val,x) => {
      //   this.createReport([],x);
      // });

      // if(this.data_allbranch.length > 0) {
      //   this.item_group.map((val,x) => {
      //     this.createReportProduct([],x);
      //   });
      // }
      this.allBranch = this.$store.state.branch_list.length;
      this.count_branch = 0;
      for (var i = 0; i < this.$store.state.branch_list.length; i++) {
        await this.getDataAllBranch(this.$store.state.branch_list[i]["id"], i);
      }
    },
    async getDataAllBranch(bId, i) {
      var obj = {
        id: bId,
        company_id: 1,
        branch_id: 1,
        begin_date: this.dateFormatDMY2(this.date_start),
        end_date: this.dateFormatDMY2(this.date_end)
      };
      this.count_branch = 0;
      await api.DashStandardCostProfit(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          if (result.response === "success") {
            this.data_allbranch.push(result.data[0]);
            var datas = [];
            // eslint-disable-next-line no-unused-vars
            var color = [
              "#00A5E3",
              "#8DD7BF",
              "#FF96C5",
              "#FF5768",
              "#FFBF65",
              "#FC6238",
              "#FFD872",
              "#F2D4CC",
              "#E77577",
              "#6C88C4",
              "#C05780",
              "#FF828B",
              "#E7C582",
              "#00B0BA",
              "#0065A2",
              "#00CDAC",
              "#FF6F68",
              "#FFDACC",
              "#FFA23A"
            ];

            var color2 = [
              { id: "สาขาแม่โจ้", color: "#8DD7BF" },
              { id: "สาขา สันติธรรม", color: "#FF96C5" },
              { id: "เจดีย์แม่ครัว", color: "#FF5768" },
              { id: "สาขาอินทร", color: "#FFBF65" },
              { id: "สาขา จอมทอง", color: "#F2D4CC" },
              { id: "สาขาสันป่าตอง", color: "#6C88C4" },
              { id: "สาขาลำพูน", color: "#00B0BA" },
              { id: "สาขาธานินท์", color: "#00A5E3" },
              { id: "สาขาเวียงป่าเป้า", color: "#B7C0DF" },
              { id: "สาขาบ่อสร้าง", color: "#B191BD" },
              { id: "สาขาป่าเหมือด", color: "#E77577" },
              { id: "สาขา สันป่าฝ้าย(ลำพูน)", color: "#6C88C4" },
              { id: "สาขาแม่ขะจาน", color: "#FF828B" },
              { id: "สาขา 89 พลาซ่า", color: "#C05780" },
              { id: "สาขาประตูเชียงใหม่", color: "#E7C582" },
              { id: "สาขา ตลาดอัศวิน(ลำปาง)", color: "#00B0BA" },
              { id: "สาขากาดหลวงเชียงราย", color: "#0065A2" },
              { id: "สาขาศรีทรายมูล", color: "#00CDAC" },
              { id: "สาขาต้นพยอม", color: "#FF6F68" },
              { id: "สาขาหางดง", color: "#FFDACC" },
              { id: "สาขาเมืองใหม่", color: "#FFA23A" }
            ];
            if (this.data_allbranch.length === 18) {
              this.item_group.map((val, p) => {
                datas = [];
                this.total_data = 0;
                this.profit_data = 0;
                $("#per" + p).html(this.numberFormatDecimal(0));
                $("#total" + p).html(this.numberFormat(0));
                $("#profit" + p).html(this.numberFormat(0));
                for (var i = 0; i < this.data_allbranch.length; i++) {
                  for (var x = 0; x < this.data_allbranch[i].length; x++) {
                    if (this.data_allbranch[i][x].group_code != 9100) {
                      if (val.name === this.data_allbranch[i][x].group_name) {
                        this.total_data += parseFloat(
                          this.data_allbranch[i][x]["total_cash_amount"]
                        );
                        this.profit_data += parseFloat(
                          this.data_allbranch[i][x]["total_profit"]
                        );
                        if (
                          color2.filter(
                            e => e.id === this.data_allbranch[i][x].branch_name
                          ).length > 0
                        ) {
                          if (this.chartType === "pie") {
                            datas.push({
                              y: this.data_allbranch[i][x]["total_cash_amount"],
                              indexLabel:
                                this.data_allbranch[i][x].branch_name +
                                " " +
                                this.numberFormat(
                                  this.data_allbranch[i][x]["total_cash_amount"]
                                ),
                              indexLabelFontFamily: "Noto Sans",
                              color: color2.filter(
                                e =>
                                  e.id === this.data_allbranch[i][x].branch_name
                              )[0].color,
                              indexLabelFontSize: 14
                            });
                          } else {
                            datas.push({
                              type: "stackedBar100",
                              name: this.data_allbranch[i][x].branch_name,
                              toolTipContent: "<b>{name}:</b> {y} (#percent%)",
                              showInLegend: true,
                              color: color2.filter(
                                e =>
                                  e.id === this.data_allbranch[i][x].branch_name
                              )[0].color,
                              dataPoints: [
                                {
                                  y: this.data_allbranch[i][x][
                                    "total_cash_amount"
                                  ],
                                  label: " "
                                }
                              ]
                            });
                          }
                        }
                      }
                    }
                  }
                }
                $("#per" + p).html(
                  this.numberFormatDecimal(
                    (this.profit_data / this.total_data) * 100
                  )
                );
                console.log("293");
                this.count_branch++;
                // eslint-disable-next-line no-undef
                $("#total" + p).html(this.numberFormat(this.total_data));
                $("#profit" + p).html(this.numberFormat(this.profit_data));
                this.createReportProduct(datas, p);
              });
            }
          }
        }
      );
    },
    createReport(Data, i) {
      if (this.chartType !== "pie") {
        // eslint-disable-next-line no-undef
        var chart = new CanvasJS.Chart("myChartincome" + i, {
          animationEnabled: true,
          theme: "light2", // "light1", "dark1", "dark2"
          dataPointWidth: 20,
          legend: {
            horizontalAlign: "center", // left, center ,right
            verticalAlign: "top", // top, center, bottom
            fontSize: 10,
            fontFamily: "Noto Sans"
          },
          axisY: {
            lineThickness: 0,
            tickThickness: 0,
            valueFormatString: " ", // space
            gridThickness: 0
          },
          axisX: {
            lineThickness: 0,
            tickThickness: 0,
            valueFormatString: " " // space
          },
          toolTip: {
            shared: false
          },
          data: Data
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      } else {
        // eslint-disable-next-line no-undef
        var chart = new CanvasJS.Chart("myChartincome" + i, {
          title: {
            text: "",
            fontFamily: "Noto Sans",
            fontSize: 16
          },
          toolTip: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          legend: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          responsive: true,
          data: [
            {
              type: "pie",
              showInLegend: false,
              legendText: "{indexLabel}",
              toolTipContent: "{indexLabel}",
              dataPoints: Data
            }
          ]
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      }
    },
    createAllReport(data) {
      // console.log("create", data);
      if (this.chartType !== "pie") {
        var chart = new CanvasJS.Chart("allMyChartincome", {
          animationEnabled: true,
          theme: "light2", // "light1", "dark1", "dark2"
          dataPointWidth: 20,
          legend: {
            horizontalAlign: "center", // left, center ,right
            verticalAlign: "top", // top, center, bottom
            fontSize: 10,
            fontFamily: "Noto Sans"
          },
          axisY: {
            lineThickness: 0,
            tickThickness: 0,
            labelFormatter: function(e) {
              return "";
            },
            gridThickness: 0
          },
          axisX: {
            lineThickness: 0,
            tickThickness: 0,
            labelFormatter: function(e) {
              return "";
            }
          },
          toolTip: {
            shared: false
          },
          data: data
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      } else {
        // eslint-disable-next-line no-undef
        var chart = new CanvasJS.Chart("allMyChartincome", {
          title: {
            text: "",
            fontFamily: "Noto Sans",
            fontSize: 16
          },
          toolTip: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          legend: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          responsive: true,
          data: [
            {
              type: "pie",
              showInLegend: false,
              legendText: "{indexLabel}",
              toolTipContent: "{indexLabel}",
              dataPoints: data
            }
          ]
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      }
    },
    createAllReportProfit(data) {
      if (this.chartType !== "pie") {
        var chart = new CanvasJS.Chart("allMyChartProfit", {
          animationEnabled: true,
          theme: "light2", // "light1", "dark1", "dark2"
          dataPointWidth: 20,
          legend: {
            horizontalAlign: "center", // left, center ,right
            verticalAlign: "top", // top, center, bottom
            fontSize: 10,
            fontFamily: "Noto Sans"
          },
          axisY: {
            lineThickness: 0,
            tickThickness: 0,
            labelFormatter: function(e) {
              return "";
            },
            gridThickness: 0
          },
          axisX: {
            lineThickness: 0,
            tickThickness: 0,
            labelFormatter: function(e) {
              return "";
            }
          },
          toolTip: {
            shared: false
          },
          data: data
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      } else {
        // eslint-disable-next-line no-undef
        var chart = new CanvasJS.Chart("allMyChartProfit", {
          title: {
            text: "",
            fontFamily: "Noto Sans",
            fontSize: 16
          },
          toolTip: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          legend: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          responsive: true,
          data: [
            {
              type: "pie",
              showInLegend: false,
              legendText: "{indexLabel}",
              toolTipContent: "{indexLabel}",
              dataPoints: data
            }
          ]
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      }
    },
    createReportProduct(Data, i) {
      if (this.chartType !== "pie") {
        var chart = new CanvasJS.Chart("myChartProduct" + i, {
          animationEnabled: true,
          theme: "light2", // "light1", "dark1", "dark2"
          dataPointWidth: 20,
          legend: {
            horizontalAlign: "center", // left, center ,right
            verticalAlign: "top", // top, center, bottom
            fontSize: 10,
            fontFamily: "Noto Sans"
          },
          axisY: {
            lineThickness: 0,
            tickThickness: 0,
            valueFormatString: " ", // space
            gridThickness: 0
          },
          axisX: {
            lineThickness: 0,
            tickThickness: 0,
            valueFormatString: " " // space
          },
          toolTip: {
            shared: false
          },
          data: Data
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      } else {
        // eslint-disable-next-line no-undef
        var chart = new CanvasJS.Chart("myChartProduct" + i, {
          title: {
            text: "",
            fontFamily: "Noto Sans",
            fontSize: 16
          },
          toolTip: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          legend: {
            fontFamily: "Noto Sans",
            fontSize: 14
          },
          responsive: true,
          data: [
            {
              type: "pie",
              showInLegend: false,
              legendText: "{indexLabel}",
              toolTipContent: "{indexLabel}",
              dataPoints: Data
            }
          ]
        });
        chart.render();
        $(".canvasjs-chart-credit").css("display", "none");
      }
    },
    getWeekStart(date) {
      var lastday = date.getDate() - date.getDay();
      return new Date(date.setDate(lastday));
    },
    getWeekEnd(date) {
      var lastday = date.getDate() - date.getDay() + 6;
      return new Date(date.setDate(lastday));
    },
    CallDashboard(bId, i) {
      var obj = {
        id: bId,
        company_id: 1,
        branch_id: 1,
        begin_date: this.dateFormatDMY2(this.date_start),
        end_date: this.dateFormatDMY2(this.date_end)
      };
      var datas = [];
      api.DashBoard(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          if (result.response === "success") {
            var rs = result.data[0];
            if (rs !== null) {
              // var data = rs[0]
              // var color = [
              //   '#00A5E3',
              //   '#8DD7BF',
              //   '#FF96C5',
              //   '#FF5768',
              //   '#FFBF65',
              //   '#FC6238',
              //   '#FFD872',
              //   '#F2D4CC',
              //   '#E77577',
              //   '#6C88C4',
              //   '#C05780',
              //   '#FF828B',
              //   '#E7C582',
              //   '#00B0BA',
              //   '#0065A2',
              //   '#00CDAC',
              //   '#FF6F68',
              //   '#FFDACC',
              //   '#FFA23A',
              // ]

              var color2 = [
                { id: "ข้าวกระสอบ 15 กิโล", color: "#8DD7BF" },
                { id: "ข้าวกิโล", color: "#FF96C5" },
                { id: "ข้าวลิตร", color: "#FF5768" },
                { id: "ไข่ไก่", color: "#FFBF65" },
                { id: "ข้าวเหนียว", color: "#F2D4CC" },
                { id: "ข้าวจ้าวหุง", color: "#6C88C4" },
                { id: "น้ำมันปาล์ม", color: "#00B0BA" },
                { id: "ข้าวกระสอบ", color: "#00A5E3" },
                { id: "ข้าวจ้าวกระสอบ", color: "#4ef5e1" },
                { id: "ข้าวเหนียวกระสอบ", color: "#89e89e" },
                { id: "น้ำแพ็ค", color: "#B7C0DF" }
              ];
              var s = 0;
              this.total_data = 0;
              this.profit_data = 0;
              rs.forEach(val => {
                if (val["group_code"] != 9100) {
                  this.total_data += val["total_cash_amount"];
                  this.profit_data += val["total_profit"];
                  if (
                    color2.filter(e => e.id === val["group_name"]).length > 0
                  ) {
                    if (this.chartType === "pie") {
                      datas.push({
                        y: val["total_cash_amount"],
                        indexLabel:
                          val["group_name"] +
                          " " +
                          this.numberFormat(val["total_cash_amount"]),
                        indexLabelFontFamily: "Noto Sans",
                        color: color2.filter(e => e.id === val["group_name"])[0]
                          .color,
                        indexLabelFontSize: 14
                      });
                    } else {
                      datas.push({
                        type: "stackedBar100",
                        name: val["group_name"],
                        toolTipContent: "<b>{name}:</b> {y} (#percent%)",
                        showInLegend: true,
                        color: color2.filter(e => e.id === val["group_name"])[0]
                          .color,
                        dataPoints: [
                          { y: val["total_cash_amount"], label: " " }
                        ]
                      });
                    }
                  }
                }

                s++;
              });

              console.log("650");
              if (this.total_data > 0) this.count_branch++;

              $("#per" + i).html(
                this.numberFormatDecimal(
                  (this.profit_data / this.total_data) * 100
                )
              );
              $("#total" + i).html(this.numberFormat(this.total_data));
              $("#profit" + i).html(this.numberFormat(this.profit_data));
              // this.createReport(datas, i);
            }
          } else {
            this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
          }
        },
        error => {
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    AllData() {
      var obj = {
        id: 0,
        company_id: 1,
        branch_id: 1,
        begin_date: this.dateFormatDMY2(this.date_start),
        end_date: this.dateFormatDMY2(this.date_end)
      };
      api.DashBoard(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          if (result.response === "success") {
            // this.$store.state.isLoading = false
            this.Sale_amount = 0;
            this.Profit_amount = 0;
            console.log(result.data);
            result.data.forEach(v => {
              // this.branchLoaded++
              if (v !== null && v.length > 0) {
                v.forEach(val => {
                  if (val["group_code"] != "9100") {
                    this.Sale_amount += val["total_cash_amount"];
                    this.Profit_amount += val["total_profit"];
                  }
                });
              }
            });
          } else {
            // this.$store.state.isLoading = false
            this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
          }
        },
        error => {
          // this.$store.state.isLoading = false
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    CallDashboardStandardCost(bId, i) {
      // console.log("caldashboard");
      this.branchLoaded = 0;
      var obj = {
        id: bId,
        company_id: 1,
        branch_id: 1,
        begin_date: this.dateFormatDMY2(this.date_start),
        end_date: this.dateFormatDMY2(this.date_end)
      };
      var datas = [];
      try {
        this.count_branch = 0;
        api.DashStandardCostProfit(
          sessionStorage.Url,
          this.header,
          obj,
          result => {
            if (result.response === "success") {
              console.log(result);
              var rs = result.data[0];
              if (rs !== null) {
                // this.branchLoaded++;

                // var data = rs[0]
                // var color = [
                //   '#00A5E3',
                //   '#8DD7BF',
                //   '#FF96C5',
                //   '#FF5768',
                //   '#FFBF65',
                //   '#FC6238',
                //   '#FFD872',
                //   '#F2D4CC',
                //   '#E77577',
                //   '#6C88C4',
                //   '#C05780',
                //   '#FF828B',
                //   '#E7C582',
                //   '#00B0BA',
                //   '#0065A2',
                //   '#00CDAC',
                //   '#FF6F68',
                //   '#FFDACC',
                //   '#FFA23A',
                // ]

                var color2 = [
                  { id: "ข้าวกระสอบ 15 กิโล", color: "#8DD7BF" },
                  { id: "ข้าวกิโล", color: "#FF96C5" },
                  { id: "ข้าวลิตร", color: "#FF5768" },
                  { id: "ไข่ไก่", color: "#FFBF65" },
                  { id: "ข้าวเหนียว", color: "#F2D4CC" },
                  { id: "ข้าวจ้าวหุง", color: "#6C88C4" },
                  { id: "น้ำมันปาล์ม", color: "#00B0BA" },
                  { id: "ข้าวกระสอบ", color: "#00A5E3" },
                  { id: "ข้าวจ้าวกระสอบ", color: "#4ef5e1" },
                  { id: "ข้าวเหนียวกระสอบ", color: "#89e89e" },
                  { id: "น้ำแพ็ค", color: "#B7C0DF" }
                ];
                var s = 0;
                this.total_data = 0;
                this.profit_data = 0;
                const listProfit = [];
                rs.forEach(val => {
                  if (val["group_code"] != 9100) {
                    this.total_data += val["total_cash_amount"];
                    this.profit_data += val["total_profit"];
                    if (
                      color2.filter(e => e.id === val["group_name"]).length > 0
                    ) {
                      if (this.chartType === "pie") {
                        datas.push({
                          y: val["total_cash_amount"],
                          indexLabel:
                            val["group_name"] +
                            " " +
                            this.numberFormat(val["total_cash_amount"]),
                          indexLabelFontFamily: "Noto Sans",
                          color: color2.filter(
                            e => e.id === val["group_name"]
                          )[0].color,
                          indexLabelFontSize: 14
                        });
                        listProfit.push({
                          y: val["total_profit"],
                          indexLabel:
                            val["group_name"] +
                            " " +
                            this.numberFormat(val["total_profit"]),
                          indexLabelFontFamily: "Noto Sans",
                          color: color2.filter(
                            e => e.id === val["group_name"]
                          )[0].color,
                          indexLabelFontSize: 14
                        });
                      } else {
                        datas.push({
                          type: "stackedBar100",
                          name: val["group_name"],
                          toolTipContent: "<b>{name}:</b> {y} (#percent%)",
                          showInLegend: true,
                          color: color2.filter(
                            e => e.id === val["group_name"]
                          )[0].color,
                          dataPoints: [
                            { y: val["total_cash_amount"], label: " " }
                          ]
                        });
                        listProfit.push({
                          type: "stackedBar100",
                          name: val["group_name"],
                          toolTipContent: "<b>{name}:</b> {y} (#percent%)",
                          showInLegend: true,
                          color: color2.filter(
                            e => e.id === val["group_name"]
                          )[0].color,
                          dataPoints: [{ y: val["total_profit"], label: " " }]
                        });
                      }
                    }
                  }
                });
                if (this.total_data > 0) this.count_branch++;
                s++;
                $("#per" + i).html(
                  this.numberFormatDecimal(
                    (this.profit_data / this.total_data) * 100
                  )
                );
                $("#total" + i).html(this.numberFormat(this.total_data));
                $("#profit" + i).html(this.numberFormat(this.profit_data));
                this.createReport(datas, i);
                this.allProductStandardCost = [
                  ...this.allProductStandardCost,
                  datas
                ].flat();
                this.allProductStandardCostProfit = [
                  ...this.allProductStandardCostProfit,
                  listProfit
                ].flat();
              }
            } else {
              this.alert_msg(
                "warning",
                "ดึงข้อมูลรายงานไม่ได้",
                result.message
              );
            }
          },
          error => {
            this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    AllDataStandardCost() {
      // console.log("all data");
      var obj = {
        id: 0,
        company_id: 1,
        branch_id: 1,
        begin_date: this.dateFormatDMY2(this.date_start),
        end_date: this.dateFormatDMY2(this.date_end)
      };
      api.DashStandardCostProfit(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          if (result.response === "success") {
            // this.$store.state.isLoading = false
            this.Sale_amount = 0;
            this.Profit_amount = 0;
            // console.log("895", result.data);
            result.data.forEach(v => {
              if (v !== null && v.length > 0) {
                v.forEach(val => {
                  if (val["group_code"] != "9100") {
                    this.Sale_amount += val["total_cash_amount"];
                    this.Profit_amount += val["total_profit"];
                  }
                });
              }
            });
          } else {
            // this.$store.state.isLoading = false
            this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
          }
        },
        error => {
          // this.$store.state.isLoading = false
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    getItemGroup() {
      apiCenter.getItemGroup(
        result => {
          if (result.data.success) {
            this.item_group = result.data.result.filter(
              e => e.name !== "น้ำพริก"
            );

            this.item_group.map((val, i) => {
              $("#per" + i).html(this.numberFormatDecimal(0));
              $("#total" + i).html(this.numberFormat(0));
              $("#profit" + i).html(this.numberFormat(0));
            });
          } else {
            this.alert_msg("warning", "ไม่สามารถเชื่อมต่อข้อมูลสาขาได้", null);
          }
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    }
  },
  watch: {
    allProductStandardCost() {
      let result = [];
      if (this.chartType === "pie") {
        result = _.chain(this.allProductStandardCost)
          .groupBy(e => e.indexLabel.split(" ")[0])
          .map((value, key) => {
            const sumY = _.sum(value.map(e => e.y));
            return {
              ...value[0],
              indexLabel: key + " " + this.numberFormat(sumY),
              y: sumY
            };
          })
          .value();
        console.log("result", result);
      } else {
        result = _.chain(this.allProductStandardCost)
          .groupBy(e => e.name)
          .map((value, key) => {
            const sumY = _.sum(value.map(e => e.dataPoints[0].y));
            const dataPoints = [{ y: sumY, x: 0, label: "" }];
            return {
              ...value[0],
              dataPoints: dataPoints
            };
          })
          .value();
      }

      this.createAllReport(result);
    },
    allProductStandardCostProfit() {
      let result = [];
      if (this.chartType === "pie") {
        result = _.chain(this.allProductStandardCostProfit)
          .groupBy(e => e.indexLabel.split(" ")[0])
          .map((value, key) => {
            const sumY = _.sum(value.map(e => e.y));
            return {
              ...value[0],
              indexLabel: key + " " + this.numberFormat(sumY),
              y: sumY
            };
          })
          .value();
      } else {
        result = _.chain(this.allProductStandardCostProfit)
          .groupBy(e => e.name)
          .map((value, key) => {
            const sumY = _.sum(value.map(e => e.dataPoints[0].y));
            const dataPoints = [{ y: sumY, x: 0, label: "" }];
            return {
              ...value[0],
              dataPoints: dataPoints
            };
          })
          .value();
      }
      this.createAllReportProfit(result);
    }
  },
  mounted() {
    this.getBranch();
    this.getItemGroup();
    // this.$store.state.isLoading = true
    setTimeout(() => {
      this.getData();
    }, 1000);
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/dashboard.js